export default function Header() {
  return (
    <div className="login-header">
      <img src="./Group 3.png" alt="logo" />
    </div>
  );
}
